import styled from '@emotion/styled';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import {
  DialogTitle,
  FormControl,
  IconButton,
  InputAdornment,
} from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

const defaultValues = {
  password: '',
  confirmPassword: '',
  currentPassword: '',
};

const UserResetPasswordModal = ({
  open,
  handleClose,
  changePasswordLoading,
  onChangePassword,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const {
    handleSubmit,
    reset,
    register,
    watch,
    formState: { errors, isSubmitted },
  } = useForm({ defaultValues });

  const password = watch('password');

  useEffect(() => {
    if (open) {
      reset(defaultValues);
      setShowPassword(false);
      setShowConfirmPassword(false);
    }
  }, [open, reset]);

  const onSubmit = data => {
    onChangePassword({
      password: data.password,
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>تغییر رمز عبور</DialogTitle>

      <DialogContent>
        {/* {!isAdmin && (
          <FormFieldWrapper>
            <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
              <TextField
                autoFocus
                dir="ltr"
                label="رمز عبور فعلی"
                type={showCurrentPassword ? 'text' : 'password'}
                variant="standard"
                sx={{ minWidth: 300 }}
                {...register('currentPassword', {
                  required: 'رمز عبور فعلی الزامی است',
                })}
                error={isSubmitted ? !!errors.currentPassword : null}
                helperText={errors.currentPassword?.message}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowCurrentPassword(prev => !prev)}
                        edge="end"
                      >
                        {showCurrentPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
          </FormFieldWrapper>
        )} */}

        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <TextField
              dir="ltr"
              autoComplete="off"
              autoFocus
              label="رمز عبور جدید"
              type={showPassword ? 'text' : 'password'}
              variant="standard"
              sx={{ minWidth: 300 }}
              {...register('password', { required: 'رمز عبور الزامی است' })}
              error={isSubmitted ? !!errors.password : null}
              helperText={errors.password?.message}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(prev => !prev)}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </FormFieldWrapper>

        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <TextField
              dir="ltr"
              label="تکرار رمز عبور"
              type={showConfirmPassword ? 'text' : 'password'}
              variant="standard"
              sx={{ minWidth: 300 }}
              {...register('confirmPassword', {
                required: 'تکرار رمز عبور الزامی است',
                validate: value =>
                  value === password || 'رمز عبور و تکرار آن یکسان نیستند',
              })}
              error={isSubmitted ? !!errors.confirmPassword : null}
              helperText={errors.confirmPassword?.message}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle confirm password visibility"
                      onClick={() => setShowConfirmPassword(prev => !prev)}
                      edge="end"
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </FormFieldWrapper>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          disabled={changePasswordLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          color="warning"
          variant="contained"
          onClick={handleSubmit(onSubmit)}
          loading={changePasswordLoading}
        >
          ذخیره
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default UserResetPasswordModal;

const FormFieldWrapper = styled.div`
  margin: 20px 8px 0;
  min-width: 300px;
`;
